// NOTE: This file should mirror the CSS breakpoints.

export const tabletBreakpoint = 768;
export const isTablet = () => window.innerWidth <= tabletBreakpoint;
